import { LocalizationText } from '_types/commonTypes';

export const mapLocalizationTextAdmin = (data): LocalizationText => ({
  key: data.Key,
  value: data.Value,
  correction: data.Correction !== null ? data.Correction : '',
  isFeText: data.IsFeText !== null ? data.IsFeText : false,
  textCorrected: data.TextCorrected !== null ? data.TextCorrected : false
});
